import React from 'react'
import { TableColumn } from '../../../components/_EOS/GenericTable'
import { Warehouse } from '../../../interfaces/Warehouse/Warehouse'
import { YesNoBadge } from '../../../components/YesNoBadge'

export const getColumnsConfig = (): TableColumn<Warehouse>[] => [
  { key: 'warehouseCode', title: 'Código'},
  { key: 'warehouseName', title: 'Nombre'},
  { key: 'postalCode', title: 'Código Postal' },
  { key: 'warehouseAddress', title: 'Dirección' },
  {
    key: 'active',
    title: 'Activo',
    render: (value: unknown) => <YesNoBadge value={value as boolean} />
  }
]
